<template>
	<div class="yaopin">
		<div class="step">
			<van-steps :active="active">
				<van-step>确认用户及卡口</van-step>
				<van-step>扫码药品条码</van-step>
				<van-step>上传处方证明</van-step>
			</van-steps>
		</div>
		<div class="container">
			<div class="box3-view" @click="skaCode">
				<div>选择卡口</div>
				<div class="example-body" style="flex: 1">{{JSON.stringify(checkDoor) != '{}' ? checkDoor.title : ''}}
				</div>
				<img src="../../static/sileiyao/003.png"></img>
			</div>
			<div class="box3-view5">
				<div class="isClassified">选择类型</div>
				<van-radio-group v-model="member_type" direction="horizontal">
					<van-radio icon-size="18px" name="1" value="1" :checked="member_type == '1'" color="#064FF2">身份证
					</van-radio>
					<van-radio icon-size="18px" name="2" value="2" :checked="member_type == '2'" color="#064FF2">东楚码
					</van-radio>
				</van-radio-group>
			</div>
			<!--上传-->
			<div v-if="member_type == '1'">
				<div class="box3-view">
					<van-cell-group>
						<van-field :border='border' class="num-view" placeholder-style="color:#C7C7C7" type="text"
							v-model="gmrname" label="真实姓名" placeholder="请输入购药人真实姓名" />
					</van-cell-group>
				</div>
				<div class="box3-view">
					<van-cell-group>
						<van-field class="num-view" placeholder-style="color:#C7C7C7" type="text" v-model="gmrsfzh"
							label="身份证号" placeholder="请输入购药人身份证号" />
					</van-cell-group>
				</div>
			</div>

			<!--扫描-->
			<div class="box2" v-if="member_type == '2'">
				<img src="../../static/sileiyao/tx.png" class="userimage"></img>
				<div class="usertext">{{scanObj.realname ? scanObj.realname : name}}</div>
				<div class="box-view-view ">
					<img src="../../static/sileiyao/003.png" @click="scanCode"></img>
				</div>
			</div>
			<div class="box3-view5">
				<div class="isClassified">购药类型</div>
				<van-radio-group v-model="gy_type" direction="horizontal">
					<van-radio icon-size="18px" name="1" value="1" :checked="gy_type == '1'" color="#064FF2">自购
					</van-radio>
					<van-radio icon-size="18px" name="2" value="2" :checked="gy_type == '2'" color="#064FF2">代购
					</van-radio>
				</van-radio-group>
			</div>
			<div class="box3-view">
				<van-cell-group>
					<van-field class="num-view" placeholder-style="color:#C7C7C7" type="text" v-model="phone"
						label="联系电话" placeholder="请输入购药人电话号码" />
				</van-cell-group>
			</div>
			<div class="box3-view">
				<div style='width: 70px'>
					居住地址
				</div>
				<div class="box3-view1">
					<div @click="showPicker1 = true">{{region?region:'请选择区域'}}</div>
					<van-popup v-model="showPicker1" round position="bottom">
					  <van-picker
					  class="vancell1"
					    show-toolbar
						value-key='name'						
					    :columns="regionTypeAry"
					    @cancel="showPicker1 = false"
					    @confirm="onConfirm1"
					  />
					</van-popup>
					<div @click="showPicker2 = true">{{street?street:'请选择街道'}}</div>
					<van-popup v-model="showPicker2" round position="bottom">
					  <van-picker
					    show-toolbar
						value-key='name'
					    :columns="streetTypeAry"
					    @cancel="showPicker2 = false"
					    @confirm="onConfirm2"
					  />
					</van-popup>
					<div @click="showPicker3 = true">{{community?community:'请选择社区'}}</div>
					<van-popup v-model="showPicker3" round position="bottom">
					  <van-picker
					    show-toolbar
						value-key='name'
					    :columns="communityTypeAry"
					    @cancel="showPicker3 = false"
					    @confirm="onConfirm3"
					  />
					</van-popup>
				</div>
				
				
			</div>
			
			<!-- <div class="box3-view">
				
				<div>居住地址</div>
				<picker :range="regionTypeAry" range-key="name" @change="regionValue">
					<div class="minpicker">{{region? region: '请选择区域' }}</div>
				</picker>
				<picker :range="streetTypeAry" range-key="name" @change="streetValue" v-if="region">
					<div class="minpicker">{{street? street: '请选择街道' }}</div>
				</picker>
				<div class="minpicker" @click="streetNone()" v-else>请选择街道</div>
				<picker :range="communityTypeAry" range-key="name" @change="communityValue" v-if="street">
					<div class="minpicker">{{community? community: '请选择社区' }}</div>
				</picker>
				<div class="minpicker" @click="communityNone()" v-else>请选择社区</div>
			</div> -->
			<div class="box3-view5">
				<div class="isClassified02">是否外地返回</div>
				<van-radio-group v-model="isback" direction="horizontal">
					<van-radio icon-size="18px" name="1" value="1" :checked="isback == '1'" color="#064FF2">是
					</van-radio>
				 <van-radio icon-size="18px" name="2" value="0" :checked="isback == '0'" color="#064FF2">否
					</van-radio>
				</van-radio-group>
			</div>
			<div class="box3-view5">
				<div class="isClassified02">是否接触疫情地区</div>
				<van-radio-group v-model="iscatch" direction="horizontal">
					<van-radio icon-size="18px" name="1" value="1" :checked="iscatch == '1'" color="#064FF2">是
					</van-radio>
				 <van-radio icon-size="18px" name="2" value="0" :checked="iscatch == '0'" color="#064FF2">否
					</van-radio>
				</van-radio-group>
			</div>

			<div class="box3-view5">
				<div class="isClassified">症状</div>
				<van-radio-group v-model="zz" direction="horizontal" class="zzradiodiv" >
					<van-radio class="zzradio" icon-size="18px" :name="item.name" v-for="(item,i) in zhengzhuang" :key=i
						:value="item.name" :checked="zz == item.name" color="#064FF2">{{item.name}}</van-radio>
				</van-radio-group>
			</div>
			<div class="box3-view-title">代购人信息</div>
			<div class="box3-view">
				<div>真实姓名</div>
				<div class="example-body" style="flex: 1">
					{{userObj.realname ? userObj.realname : ''}}
				</div>
			</div>
			<div class="box3-view">
				<div>联系电话</div>
				<div class="example-body" style="flex: 1">
					{{userObj.mobile ? userObj.mobile : ''}}
				</div>
			</div>
		</div>
		<div class="liability-exemption-wrap">
			<van-radio-group v-model="status">
				<van-radio name="1" @click="tongyi1">同意</van-radio>

			</van-radio-group>

			<!-- 			<label class="liability-exemption-title" @click="status = !status">
				<checkbox class="liability-exemption-checkbox" :checked="status" />同意
			</label>
 -->
			<p @click.stop="gotoAgreement02()" class="liability-exemption-text">《用户服务协议》</p>
			<p @click.stop="gotoAgreement()" class="liability-exemption-text">《隐私政策》</p>
		</div>
		<div class="submit_div">
			<button form-type="submit" class="submit_btn" :disabled="!(status*1)" @click="next()">下一步</button>
		</div>

		<div class="footer-Main">
			<div class="footer-Main-title">注意：</div>
			<div>步骤一：请选择药店卡口，并确认用户信息。用户信息可通过上传身份证或扫描东楚码来确认</div>
			<div>步骤二：通过手机扫码所有购买的药品</div>
			<div>步骤三：请上传医院处方证明</div>
		</div>
	</div>
</template>

<script>
	import imgTools from '@/static/js/imgOper.js'
	import {
		getCascade,getKakouFindById,decodeField,findUserByIdCard,finddoorbuyId
	} from "@/api/index.js"
	import {
			Toast
		} from 'vant';
	export default {
		name: "index",
		data() {
			return {
				userinfo:{},
				zhengzhuang: [
					{name: '发热'
					},
					{
						name: '气促'
					},
					{
						name: '咳嗽'
					},
					{
						name: '畏寒'
					},
					{
						name: '乏力'
					},
					{
						name: '结膜充血'
					},
					{
						name: '腹泻'
					},
					{
						name: '呼吸困难'
					},
					{
						name: '其他'
					},
				],
				status: false,
				name: "请扫码获取东楚通用户信息",
				img: "../../static/linxiaokang/me/tx.png",
				member_type: '2', // 人员出示证明的方式				
				isback: '', //是否外地返回
				iscatch: '', //是否接触疫情地区
				zz: '其他', // 症状  
				gy_type: 1, // 购药方式
				cardTypeAry: [], // 卡口集合
				keyName: 'title',
				index: -1, // 默认选中
				imageList: [],
				checkDoor: {},
				tyshxydm: '',
				regionTypeAry: [], // 区域集合
				region: '',
				streetTypeAry: [], // 街道集合
				street: '',
				communityTypeAry: [], // 社区集合
				community: '',
				userObj: {}, // 代购人姓名、电话(登录用户)
				gmrname: '', // 购药人真实姓名
				gmrsfzh: '', // 购药人身份证号
				phone: '', // 购药人联系电话
				scanObj: {}, // 通过东楚码扫描的购药人
				tempImg: '',
				ultraType: 0,
				active: 0,
				tongyicleck: false,
				border: false,
				value: '',
				showPicker1: false,
				showPicker2: false,
				showPicker3: false,
			}
		},
		onShow() {

			const _this = this
			this.$wx.getUserinfo((user) => {
				if (user.data) {
					this.userObj = {
						realname: user.data.realname,
						mobile: user.data.mobile
					}
				}
			}, true)
		},
		mounted() {
			AlipayJSBridge.call('getItem', {
				key: 'userinfo'
			}, (result) => {
				this.userinfo =JSON.parse(result.userinfo) 
				console.log('this.userinfo',this.userinfo)
			});
			//获取区级单位信息
			this.getCascade(0,'')			
			console.log('this.$route.query',this.$route.query)
			let ultraType=this.$route.query.ultraType
			let stepOne = localStorage.getItem('gyStepOne')
			if (stepOne) {
				let obj = JSON.parse(stepOne);
				this.checkDoor.id = obj.kakouId;
				this.checkDoor.title = obj.kakouName;
				this.index = 1;
				if (ultraType == 1) {
					this.isback = obj.isback;
					this.iscatch = obj.iscatch;
					this.zz = obj.zz;
					this.gy_type = obj.gy_type;
					this.member_type = obj.userType;
					this.phone = obj.gmr_dh;
					this.userObj.mobile = obj.dgr_dh;
					this.userObj.realname = obj.dgr_name;
					this.region = obj.gyrczdq;
					this.street = obj.gyrczdjd;
					this.community = obj.gyrczdsq;
					if (this.member_type == 1) {
						//	this.imageList = obj.idcardImg;
						this.gmrname = obj.gmr_name;
						this.gmrsfzh = obj.gmrsfzh;
					}
					if (this.member_type == 2) {
						this.scanObj.id = obj.member_id;
						this.scanObj.realname = obj.realName;
						this.scanObj.idcard = obj.idcard;
					}
					this.ultraType = 1
				}
			}
			this.getCascade(0, '').then(res => {
				this.regionTypeAry = res.list
			})
		},
		methods: {
			//扫码根据id获取卡口信息
			async getKakouFindById(id){
				console.log('id',id)
				let params={
					id:id,
				}
				let res=await getKakouFindById(params)
				console.log('卡口信息',res)
				this.checkDoor = res.result.obj;
				this.index = 1;
			},
			//选择地址并获取下一级信息
			onConfirm1(e){
				this.showPicker1=false
				let value = e.name;
				this.region = value;
				this.street =''
				this.community =''
				this.getCascade(1, value)
			},
			onConfirm2(e){
				this.showPicker2=false
				let value = e.name;
				this.street = value;
				this.community =''
				this.getCascade(4, value)
			},
			onConfirm3(e){
				this.showPicker3=false
				this.community=e.name
			},
			//根据地址获取下级信息
			async getCascade(level,parent) {
				console.log(level,parent)
				let params = {
					level: level,
					parent:parent,
				}
				console.log('2222asda',params)
				let res = await getCascade(params)
				console.log('卡扣权限', res)
				if(level==0){
					this.regionTypeAry=res.result.list
				}else if(level==1){
					 // 切换选中-区域
					this.streetTypeAry=res.result.list
				}else if(level==4){
					// 切换选中-街道
					this.communityTypeAry=res.result.list
				}
				
			},
			//切换同意不同意
			tongyi1(e) {
				this.tongyicleck = !this.tongyicleck
				if (this.tongyicleck) {
					this.status = 1 + ''
				} else {
					this.status = 0 + ''
				}
			},
			// // 切换选中-区域
			regionValue(e) {
				let value = this.regionTypeAry[e.target.value].name;
				this.region = value;
				this.street = ''
				this.community = ''
				this.getCascade(1, value).then(res => {
					this.streetTypeAry = res.list
				})
			},
			// 切换选中-街道
			streetValue(e) {
				let value = this.streetTypeAry[e.target.value].name;
				this.street = value;
				this.community = ''
				this.getCascade(4, value).then(res => {
					this.communityTypeAry = res.list
				})
			},
			// 切换选中-社区
			communityValue(e) {
				this.community = this.communityTypeAry[e.target.value].name;
			},
			
			

			valid() {
				let msg = '';
				let that = this;
				if (that.index == -1) {
					msg = '请先选择您对应的药店卡口';
				} else if (that.member_type == 1) {
					// if(this.imageList.length === 0){
					//     msg = '请上传身份证';
					// }
					if (!that.gmrname) {
						msg = '请输入购药人真实姓名';
					} else {
						if (!(/^[\u4e00-\u9fa5]{2,8}$/.test(that.gmrname.trim()))) {
							msg = '请输入正确的中文名';
						}
					}
					if (!that.gmrsfzh) {
						msg = '请输入购药人身份证号码';
					} else {
						if (!imgTools.isIdcard(that.gmrsfzh)) {
							msg = '请输入正确的身份证号码';
						}
					}
				} else if (that.member_type == 2) {
					if (JSON.stringify(that.scanObj) == '{}') {
						msg = '请扫东楚通码';
					}
				}
				if (!that.phone) {
					msg = '请输入购药人电话号码';
				}
				if (!(/^1(3|4|5|6|7|8|9)\d{9}$/.test(that.phone.trim()))) {
					msg = '请输入正确的手机号';
				}
				if (!that.community) {
					msg = '请选择社区';
				}
				if (!that.street) {
					msg = '请选择街道';
				}
				if (!that.region) {
					msg = '请选择区域';
				}
				if (!that.isback) {
					msg = '请选择是否外地返回';
				}
				if (!that.iscatch) {
					msg = '请选择是否接触疫情地区';
				}
				return msg;
			},
			async next() {
				let msg = this.valid();
				if (msg) {
					Toast.fail(msg)
				} else {
					console.log('this.checkDoor.id;',this.checkDoor.id)
					let doorId = this.checkDoor.id;
					let params={
						id:doorId
					}
					let res=await finddoorbuyId(params)
					console.log('res12',res)
					let tyshxydm=res.result.tyshxydm
						if (!tyshxydm) {
							Toast.fail('请扫描规范的卡口二维码进行登记')
						} else {
							// 1.记录缓存数据
							let obj = {}
							obj.isback = this.isback;
							obj.iscatch = this.iscatch;
							obj.zz = this.zz;
							obj.gy_type = this.gy_type;
							obj.kakouId = doorId;
							obj.kakouName = this.checkDoor.title;
							obj.userType = this.member_type; // 1代表身份证用户，2代表东楚码用户
							obj.gmr_dh = this.phone;
							obj.dgr_dh = this.userObj.mobile;
							obj.dgr_name = this.userObj.realname;
							obj.gyrczdq = this.region;
							obj.gyrczdjd = this.street;
							obj.gyrczdsq = this.community;
							if (this.member_type == 1) {
								//  obj.idcardImg = this.imageList;
								obj.gmr_name = this.gmrname;
								obj.gmrsfzh = this.gmrsfzh;
							}
							if (this.member_type == 2) {
								obj.member_id = this.scanObj.id
								obj.realName = this.scanObj.realname
								obj.idcard = this.scanObj.idcard
							}
							localStorage.setItem('gyStepOne',JSON.stringify(obj))
							// 2.跳转
							if (this.ultraType == 1) {
								this.$router.push({
						 			path: '/yaoguanAddtwo',
									query: {
										ultraType: 2,
									}
								})								
							} else {
								this.$router.push('yaoguanAddtwo')
							}
						}
				}
			},
			//扫码获取用户信息
			scanCode() {
				console.log('22222')
				// 微信小程序扫码-东楚码
				let that=this
				AlipayJSBridge.call('scan', {
				  type: 'bar',
				  actionType: 'scanAndRoute'
				}, function(result) {
				    let data = JSON.parse(result.qrCode)
					that.decodeField(data.idcard)
				});
			},
			// '身份证解密'
			async decodeField(id){
				let params={
					encryptedField:id
				}
				let res=await decodeField(params)
				this.findUserByIdCard(res.result.obj)
			},
			// 通过身份证号获取用户信息
			async findUserByIdCard(id){
				let params={
					idcard:id
				}
				let res=await findUserByIdCard(params)
				this.scanObj=res.result.obj
				this.userObj.realname=res.result.obj.realname
				this.userObj.mobile=res.result.obj.mobile
			},
			
			//扫码获取卡口信息
			skaCode() {
				// 微信小程序扫码-卡口
				let that=this
				AlipayJSBridge.call('scan', {
				  type: 'bar',
				  actionType: 'scanAndRoute'
				}, function(result) {
				    var paraString = result.qrCode;
					var paras = paraString.split("=");
					let parasID = paras[1];
					that.getKakouFindById(parasID)					
				});				
			},
			// 跳转协议1
			gotoAgreement() {
				this.$router.push('yaoguanagreement01')
			},
			// 跳转协议2
			gotoAgreement02() {
				this.$router.push('yaoguanagreement02')
			},
		}
	}
</script>
<style scoped>
	.yaopin {
		padding: 0 20px;
	}

	.step {
		padding: 10px 0;
	}

	.container {
		position: relative;
		font-size: 14px;
	}

	.van-cell {
		padding: 0;
	}
	.vancell1{
		font-size: 14px;
		text-align: center;
	}
	.box3-view1{
		flex:1;
		display: flex;
		align-items: center;
	}
	.box3-view1 div{
		margin-right: 10px;
		font-size: 12px;;
	}
	.van-field__label{
		margin-right:0 !important;
	}
	.van-field__control{
		width: 100px !important;
	}
	.status-btn {
		/* #ifndef APP-NVUE */
		display: flex;
		/* #endif */
		flex-direction: row;
		align-items: center;
		justify-content: center;
		height: 40px;
		margin: 15px;
		background-color: #007AFF;
	}

	.box2 {
		width: 100%;
		height: 80px;
		background: white;
		display: flex;
		align-items: center;
		box-sizing: border-box;
		border-bottom: 1px solid rgba(238, 238, 238, 1);
	}

	.box2 .userimage {
		width: 50px;
		height: 50px;
		margin-right: 10px;
		border-radius: 100%;
	}

	.box2 .usertext {
		flex: 1;
	}

	.box-view-view {
		padding: 15rpx 0;
		text-align: right;
		width: 22px;
		height: 20px;
	}

	.box-view-view>img {
		width: 20px;
		height: 20px;
	}

	.minpicker {
		font-size: 14px;
	}

	.box3-view-title {
		padding: 10px;
		font-size: 14px;
		color: rgb(153, 153, 153);
		background-color: #f2f2f2;
	}

	.box3-view,
	.box3-view5 {
		display: flex;
		align-items: center;
		justify-content: space-between;
		width: 100%;
		margin: auto;
		padding: 10px 0;
		border-bottom: 1px solid rgba(238, 238, 238, 1);
	}

	.box3-view>view:nth-of-type(1),
	.isClassified {
		width: 90px;
		font-size: 14px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(64, 64, 66, 1);
		text-align: left;
	}

	.box3-view img {
		width: 22px;
		height: 20px;
	}

	.box3-view5 {
		justify-content: flex-start;
	}

	.isClassified {
		width: 70px !important;
	}

	.isClassified02 {
		width: 130px;
		font-size: 14px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(64, 64, 66, 1);
	}

	.radio,
	.radio02 {
		transform: scale(0.8);
	}

	.radio text,
	.radio02 text {
		font-size: 20px;
		color: rgba(64, 64, 66, 1);
	}

	.radio-group {
		margin-left: 5px;
	}

	.radio-group02 {
		margin-left: 5px;
	}

	.radio {
		margin-right: 13px;
	}

	.radio02 {
		margin: 5px 12px;
	}

	input,
	.picker-view {
		width: 240px;
		box-sizing: border-box;
		padding: 0 10px;
		color: rgba(64, 64, 66, 1);
		font-size: 16px;
	}

	.input {
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #C7C7C7;
	}

	.picker-view {
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: rgba(203, 207, 208, 1);
	}

	.picker-view-true {
		width: 240px;
		box-sizing: border-box;
		padding: 0 5px;
		font-size: 16px;
		font-family: Microsoft YaHei;
		font-weight: 400;
		color: #404042;
	}

	.box3-view>img {
		width: 20px;
		height: 20px;
	}

	.box3-view6 {
		width: 96%;
		padding: 8px 0;
		margin: auto;
		overflow: hidden;
		border-bottom: 1px solid rgba(238, 238, 238, 1);
	}

	.box3-view6 .file_view {
		margin: 8px 15px;
		color: #DFDFDF;
		width: 75px;
		text-align: center;
		height: 75px;
		line-height: 75px;
		border: 1px solid #DFDFDF;
		font-size: 60px;
		float: left;
	}

	.box3-view6-list {
		width: 75px;
		height: 75px;
		float: left;
		margin: 8px 15px;
	}

	.box3-view6-list>image {
		width: 100%;
		height: 100%;
	}

	.submit_div {
		text-align: center;
		padding: 30px 0;
	}

	.submit_btn {
		width: 90%;
		height: 50px;
		background-color: #4293F4;
		color: #FFFFFF;
		font-size: 18px;
		border-radius: 10px;
	}

	.footer-Main {
		font-size: 12px;
		padding: 10px;
		color: rgb(153, 153, 153);
		background-color: #f2f2f2;
	}

	.footer-Main-title {
		font-size: 18px;
	}

	.footer-Main>div {
		margin: 10px;
		color: rgb(153, 153, 153);
	}

	.liability-exemption-wrap {
		padding: 0 20px;
		margin-top: 25px;
		font-size: 15px;
		display: flex;
		align-items: center;
	}

	.liability-exemption-wrap .liability-exemption-checkbox {
		transform: scale(.86);
	}

	.liability-exemption-title {
		display: inline-block;
	}

	.liability-exemption-wrap .liability-exemption-text {
		color: #4293F4;
	}

	/* 症状 */
	.zzradiodiv {
		display: flex;
		flex-wrap: wrap;
	}

	.zzradio {
		margin-right: 10px;
		padding: 5px 0;
	}
	.example-body{
		margin-left: 10px;
	}
</style>
